import React from 'react'
import './ScaleAI.scss'

interface IScaleAI {
  accuracy: number
  id: number
}

export const ScaleAI = ({ accuracy, id }: IScaleAI) => {
  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
            .ai-scale-wrap-id-${id}::before {
              content: '';
              position: absolute;
              top: -5px;
              right: ${Math.round(accuracy) - 4.5}%;
              width: 26px;
              height: 26px;
              border-radius: 50%;
              background: rgba(140, 82, 233, 0.3);
            }
          `,
        }}
      ></style>
      <div className={`ai-scale-wrap ai-scale-wrap-id-${id}`}>
        <div className={`cm ${Math.round(accuracy) === 100 ? 'accuracy' : ''}`}>
          <div
            className={`mm ${Math.round(accuracy) === 99 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 98 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 97 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 96 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 95 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 94 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 93 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 92 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 91 ? 'accuracy' : ''}`}
          ></div>
        </div>
        <div className={`cm ${Math.round(accuracy) === 90 ? 'accuracy' : ''}`}>
          <div
            className={`mm ${Math.round(accuracy) === 89 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 88 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 87 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 86 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 85 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 84 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 83 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 82 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 81 ? 'accuracy' : ''}`}
          ></div>
        </div>
        <div className={`cm ${Math.round(accuracy) === 80 ? 'accuracy' : ''}`}>
          <div
            className={`mm ${Math.round(accuracy) === 79 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 78 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 77 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 76 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 75 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 74 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 73 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 72 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 71 ? 'accuracy' : ''}`}
          ></div>
        </div>
        <div className={`cm ${Math.round(accuracy) === 70 ? 'accuracy' : ''}`}>
          <div
            className={`mm ${Math.round(accuracy) === 69 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 68 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 67 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 66 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 65 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 64 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 63 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 62 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 61 ? 'accuracy' : ''}`}
          ></div>
        </div>
        <div className={`cm ${Math.round(accuracy) === 60 ? 'accuracy' : ''}`}>
          <div
            className={`mm ${Math.round(accuracy) === 59 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 58 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 57 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 56 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 55 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 54 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 53 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 52 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 51 ? 'accuracy' : ''}`}
          ></div>
        </div>
        <div className={`cm ${Math.round(accuracy) === 50 ? 'accuracy' : ''}`}>
          <div
            className={`mm ${Math.round(accuracy) === 49 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 48 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 47 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 46 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 45 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 44 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 43 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 42 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 41 ? 'accuracy' : ''}`}
          ></div>
        </div>
        <div className={`cm ${Math.round(accuracy) === 40 ? 'accuracy' : ''}`}>
          <div
            className={`mm ${Math.round(accuracy) === 39 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 38 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 37 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 36 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 35 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 34 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 33 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 32 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 31 ? 'accuracy' : ''}`}
          ></div>
        </div>
        <div className={`cm ${Math.round(accuracy) === 30 ? 'accuracy' : ''}`}>
          <div
            className={`mm ${Math.round(accuracy) === 29 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 28 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 27 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 26 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 25 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 24 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 23 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 22 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 21 ? 'accuracy' : ''}`}
          ></div>
        </div>
        <div className={`cm ${Math.round(accuracy) === 20 ? 'accuracy' : ''}`}>
          <div
            className={`mm ${Math.round(accuracy) === 19 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 18 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 17 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 16 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 15 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 14 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 13 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 12 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 11 ? 'accuracy' : ''}`}
          ></div>
        </div>
        <div className={`cm ${Math.round(accuracy) === 10 ? 'accuracy' : ''}`}>
          <div
            className={`mm ${Math.round(accuracy) === 9 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 8 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 7 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 6 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 5 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 4 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 3 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 2 ? 'accuracy' : ''}`}
          ></div>
          <div
            className={`mm ${Math.round(accuracy) === 1 ? 'accuracy' : ''}`}
          ></div>
        </div>
        <div
          className={`cm ${Math.round(accuracy) === 0 ? 'accuracy' : ''}`}
        ></div>
      </div>
    </>
  )
}
